import { Button } from 'antd'
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import { useIntl } from 'react-intl'
import { useIntercom } from 'react-use-intercom'

import { ResultWithIllustration } from './ResultWithIllustration'
import { buildI18nFunction, composePageTitle } from '@/utils/messages'

const COMPONENT_ID = 'ResultErrorGeneric'

type ResultErrorGeneric = {
  componentId?: 'Generic' | 'ErrorBoundary' | 'WrongWorkspace'
  isFullPage?: boolean
  hasIntercom?: boolean
}

export function ResultErrorGeneric({
  componentId = 'Generic',
  isFullPage = true,
  hasIntercom = true,
}: ResultErrorGeneric): JSX.Element {
  const t = buildI18nFunction(useIntl().formatMessage)
  const { showNewMessage: showIntercom } = useIntercom()
  return (
    <div
      data-cy={COMPONENT_ID}
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        justifyContent: 'center',
      }}
    >
      {isFullPage && (
        <Head>
          <title>
            {composePageTitle(
              t(`${COMPONENT_ID}.${componentId}.Head.title`).toString()
            )}
          </title>
        </Head>
      )}
      <ResultWithIllustration
        extra={
          isFullPage === true
            ? [
                <Button
                  key={`${componentId}-callToAction`}
                  onClick={() => window.location.replace('/')}
                  type="primary"
                >
                  <Link href="/">
                    {t(`${COMPONENT_ID}.${componentId}.extra.callToAction`)}
                  </Link>
                </Button>,
                hasIntercom === true && (
                  <Button
                    key={'ErrorBoundary-callToAction'}
                    onClick={() => showIntercom()}
                    type="default"
                  >
                    Contact Support
                  </Button>
                ),
              ]
            : null
        }
        icon={getCustomIcon(componentId)}
        title={t(`${COMPONENT_ID}.${componentId}.title`)}
        subTitle={t(`${COMPONENT_ID}.${componentId}.subTitle`)}
      />
    </div>
  )
}

export function getCustomIcon(componentId: string): JSX.Element {
  if (componentId === 'WrongWorkspace') {
    return (
      <Image
        alt="wrong workspace"
        height={280}
        objectFit="contain"
        priority
        src={`/images/illustrations/archived.svg`}
        width={280}
      />
    )
  }

  return (
    <Image
      alt="An error has occured"
      height={280}
      objectFit="contain"
      priority
      src={`/images/illustrations/error.svg`}
      width={280}
    />
  )
}
